import type { nanoid as FunctionNanoID } from "nanoid";

export const { nanoid } = require("nanoid") as {
  nanoid: typeof FunctionNanoID;
};
